import { race, throwError, timer } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { StreemError } from '../../streem_error';
import { logger } from '../logger';
import { filterNull } from './filter_null';
export async function artifactTimedResponse(latestRequestId, latestResponses, opts) {
    const { timeout = 30000 } = opts ?? {};
    if (timeout < 0) {
        throw new StreemError('Timeout must be greater than 0ms');
    }
    // After timeout, return unfulfilled request
    const timedFailure = timer(timeout).pipe(switchMap(() => {
        logger.warn(`Artifact request ${latestRequestId} has timed out`);
        return throwError('Request timed out');
    }));
    // Attempt to find a geolocation or streemshot response that matches latestRequestId
    const matchingResponse = latestResponses.pipe(map((responses) => responses.find(res => res.inResponseToWallItemId === latestRequestId)), filterNull(), tap(() => logger.info(`Artifact request ${latestRequestId} has been fulfilled`)));
    // Possible improvement: firstValueFrom when moving to rxjs 7
    return new Promise((resolve, reject) => {
        let value;
        race(timedFailure, matchingResponse)
            .pipe(take(1))
            .subscribe((x) => (value = x), err => reject(err), () => resolve(value));
    });
}
//# sourceMappingURL=artifact_timed_response.js.map